import { Controller } from 'stimulus'
import Swiper, { Navigation, Scrollbar, Autoplay } from 'swiper/core';
import throttle from '../utils/throttle'

Swiper.use([Navigation, Scrollbar, Autoplay]);

const OFFSET = 75
export default class extends Controller {
  static targets = ['inner', 'container', 'next', 'prev', 'nav', 'scrollbar']

  initialize() {
    this._handleScroll = throttle(this.handleScroll.bind(this), 100)
    this._handleResize = throttle(this.handleResize.bind(this), 100)
  }

  setNavActive(index) {
    this._navSlides.forEach(slide => slide.classList.remove('active'))
    this._navSlides[index].classList.add('active')
  }

  goTo(e) {
    const index = Array.from(e.currentTarget.parentElement.children).indexOf(e.currentTarget)
    this._swiper.slideTo(index)
  }

  restartCurrentSlide() {
    const currentIndex = this._swiper.realIndex
    this._swiper.slideReset()
    this.startVideo()
    this._navSlides[currentIndex].classList.remove('active')
    setTimeout(() => {
      this.setNavActive(currentIndex)
    }, 1)
  }

  handleScroll() {
    const position = this.element.getBoundingClientRect()
    const inView = position.top < (OFFSET / 100) * window.innerHeight && position.top > 0

    if (inView) {
      if (!this._swiper.autoplay.paused) return
      this._swiper.autoplay.run()
      this._swiper.autoplay.paused = false
      this.restartCurrentSlide()
    } else {
      if (this._swiper.autoplay.paused) return
      this._swiper.autoplay.pause()
    }
  }

  handleResize() {
    this.innerTarget.style.minHeight = `${this.navTarget.offsetHeight}px`
  }

  unbindScroll() {
    window.removeEventListener('scroll', this._handleScroll)
  }

  startVideo() {
    const activeSlide = this._swiper.slides[this._swiper.realIndex]
    const video = activeSlide.querySelector('video')
    if (video != null) {
      video.currentTime = 0
      setTimeout(() => video.play().catch(e => console.log('Animation failed to play:', e)), 1)
    }
  }

  connect() {
    this._navSlides = Array.from(this.navTarget.children)
    this._swiper = new Swiper(this.containerTarget, {
      navigation: { nextEl: this.nextTarget, prevEl: this.prevTarget },
      scrollbar: { el: this.scrollbarTarget, hide: false },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      on: {
        slideChange: () => this.setNavActive(this._swiper.realIndex),
        init: () => this.setNavActive(0),
        afterInit: () => this.handleResize(),
        slideChangeTransitionStart: () => this.startVideo(),
      },
    })

    window.addEventListener('scroll', this._handleScroll)
    window.addEventListener('resize', this._handleResize)
    this.handleScroll()
  }

  disconnect() {
    this.unbindScroll()
  }
}
